export const EAuthFlagName = 'IsAuth';
